import React from 'react';
import { Accordion, AccordionItem, AccordionHeader, AccordionBody, Icon } from '@hz-design-system/web-ui';
import { Trans } from '@ecg-marktplaats/js-react-i18n';

import { TListingCarAttributes } from 'types/TListing';

import Classes from './CarAttributesAccordion.scss';

type TCarAttributesAccordionProps = {
  carAttributes: TListingCarAttributes;
};

const MAIN_GROUP_KEY = 'Main';

const CarAttributesAccordion = ({ carAttributes }: TCarAttributesAccordionProps) => {
  if (!Boolean(carAttributes.groupedWithIcons?.length)) {
    return null;
  }

  return (
    <Accordion className={Classes.root}>
      {carAttributes.groupedWithIcons
        .filter((group) => group.key !== MAIN_GROUP_KEY)
        .map((group) => (
          <AccordionItem key={group.key} className={Classes.item}>
            <AccordionHeader className={Classes.header}>
              <Icon className={Classes.headerIcon} color="text-primary" name={group.icon ?? ''} />
              <Trans className={Classes.headerLabel} tagName="span" i18nKey={group.label ?? ''} />
            </AccordionHeader>
            <AccordionBody className={Classes.body} onClick={(event) => event.stopPropagation()}>
              {group.attributes.map((item) => {
                const attributeHasValues = item.values && item.values.length > 1;
                return (
                  <div className={`${Classes.bodyItems} ${attributeHasValues && Classes.valuesList}`} key={item.key}>
                    <div className={Classes.bodyItemLabel}>{!attributeHasValues && item.label}</div>
                    <div className={Classes.bodyItemValue}>
                      {attributeHasValues && (
                        <ul className={Classes.optionsValues}>
                          {item.values?.map((option) => (
                            <li key={option}>{option}</li>
                          ))}
                        </ul>
                      )}
                      {!attributeHasValues && `${item.value || item.values?.[0]} ${item.unit ?? ''}`}
                    </div>
                  </div>
                );
              })}
            </AccordionBody>
          </AccordionItem>
        ))}
    </Accordion>
  );
};

export default CarAttributesAccordion;
